import * as auth from '@babylon/babylon-auth'
import { AuthClient, getAuthClient } from '@babylon/web-platform-utils-auth'

import { ENABLE_NEW_AUTH } from '~/constants'
import { LOGOUT_ACTION, LOGOUT_CATEGORY } from '~/constants/analytics'
import analytics from '~/core/analytics'
import { disconnectSendbirdRestClient } from '~/features/telus-async-chat/sendbirdRestClient'

const newLogout = async () => {
  const authClient: AuthClient = getAuthClient()
  await authClient.logout()
}

const logout = async () => {
  analytics.trackEvent({
    action: LOGOUT_ACTION,
    category: LOGOUT_CATEGORY,
  })

  // Fire-and-forget: module state (instance/userId) is reset synchronously
  // at the top of the function, so the next login always gets a clean slate.
  // The async disconnect() call is best-effort and must not block logout.
  disconnectSendbirdRestClient()

  /*
   we should remove the ENABLE_NEW_AUTH flag and old auth when migration is complete , see:
   babylonpartners.atlassian.net/wiki/spaces/CIT/pages/4241555535/Portals+Open+ID+switchover
  */
  try {
    if (ENABLE_NEW_AUTH) {
      await newLogout()
    } else {
      await auth.logout()
    }
  } catch (exception) {
    console.warn(exception)
  }
}

export default logout
